import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay, Navigation } from "swiper";
import Member from "./Member";

import "swiper/scss";
import "swiper/scss/autoplay";

import classes from "./Team.module.scss";
import Arrows from "./Arrows";
import BaseContainer from "@components/ui/BaseContainer";
import useWindowSize from "@utils/hooks/ui/useWindowSize";
import { AnimationOnScroll } from "react-animation-on-scroll";

const Team = () => {
  const { t } = useTranslation();

  const { isMobile } = useWindowSize();

  const team: { img: string; fullName: string; position: string }[] = t("team.list", { returnObjects: true });

  return (
    <BaseContainer className={classes.team} id="team">
      <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce>
        <h3 className={classes.team__title}>{t("team.title")}</h3>
      </AnimationOnScroll>
      <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce>
        <Swiper
          className={classes.team__list}
          modules={[Autoplay, Navigation]}
          tag="ul"
          slidesPerView={isMobile ? 1.5 : 2.3}
          spaceBetween={0}
          loop
          mousewheel
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
        >
          {team.map((member) => (
            <SwiperSlide tag="li" key={member.fullName}>
              {({ isActive }) => (
                <Member
                  img={require(`@assets/images/main/team/default/${member.img}.png`)}
                  imgHover={require(`@assets/images/main/team/hover/${member.img}.png`)}
                  name={member.fullName}
                  position={member.position}
                  isActive={isActive}
                />
              )}
            </SwiperSlide>
          ))}

          <Arrows />
        </Swiper>
      </AnimationOnScroll>
    </BaseContainer>
  );
};

export default Team;
